import withResolvers from 'promise.withresolvers';

withResolvers.shim();
